import React, { useEffect, useState } from "react"
import { Switch, SimpleSelect } from "components/fields";
import { Button } from "components";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { getListServers as getListServersAction, getListRoles as getListRolesAction } from "./actions";
import useTheme from "../../../../../../../../hooks/useTheme";
import config from "constants/config";
import { getSelfUser } from "../../../../../../../../services/auth/actions";

import "./index.scss";


const Discord = ({ isDark }) => <svg xmlns="http://www.w3.org/2000/svg" style={{ width: 85, height: "100%" }} version="1.1" viewBox="0 0 492 92">
    <path d="m33.2 1.3h-33.2v37.6l22.1 20v-36.5h11.9c7.5 0 11.2 3.7 11.2 9.5v27.9c0 5.8-3.5 9.7-11.2 9.7h-34v21.2h33.2c17.8 0.1 34.5-8.8 34.5-29.4v-30.1c0-20.8-16.7-29.9-34.5-29.9zm174 60.1v-30.8c0-11.1 19.8-13.7 25.8-2.5l18.3-7.5c-7.1-15.9-20.3-20.6-31.2-20.6-17.8 0-35.4 10.4-35.4 30.6v30.8c0 20.3 17.6 30.6 35 30.6 11.2 0 24.6-5.6 32-20.1l-19.6-9.1c-4.8 12.4-24.9 9.4-24.9-1.4zm-60.6-26.6c-6.9-1.5-11.5-4-11.8-8.3 0.4-10.4 16.3-10.7 25.6-0.8l14.7-11.4c-9.2-11.3-19.6-14.3-30.4-14.3-16.3 0-32.1 9.2-32.1 26.8 0 17.1 13 26.2 27.3 28.4 7.3 1 15.4 3.9 15.2 9-0.6 9.6-20.2 9.1-29.1-1.8l-14.1 13.4c8.3 10.7 19.6 16.2 30.2 16.2 16.3 0 34.4-9.5 35.1-26.8 1-22-14.8-27.5-30.6-30.4zm-66.9 55.9h22.4v-89.4h-22.4zm378-89.4h-33.2v37.6l22.1 20v-36.5h11.8c7.5 0 11.2 3.7 11.2 9.5v27.9c0 5.8-3.5 9.7-11.2 9.7h-34v21.2h33.2c17.8 0.1 34.5-8.8 34.5-29.4v-30.1c0.1-20.8-16.6-29.9-34.4-29.9zm-163-1.3c-18.4 0-36.7 10.1-36.7 30.7v30.6c0 20.5 18.4 30.7 36.9 30.7 18.4 0 36.7-10.2 36.7-30.7v-30.6c0-20.5-18.5-30.7-36.9-30.7zm14.4 61.3c0 6.4-7.2 9.7-14.3 9.7-7.2 0-14.4-3.2-14.4-9.7v-30.6c0-6.6 7-10.1 14-10.1 7.3 0 14.7 3.2 14.7 10.1zm103-30.6c-0.5-21-14.7-29.4-33-29.4h-35.5v89.5h22.7v-28.5h4l20.6 28.4h28l-24.2-30.7c10.8-3.4 17.4-12.7 17.4-29.3zm-32.6 12.1h-13.2v-20.4h13.2c14.2 0 14.2 20.4 0 20.4z"  fill={isDark ? "var(--black1)" : "white"} />
</svg>;


const RefreshIcon = () => <svg
    width="20"
    height="20"
    className=""
    style={{}}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
>
    <path
        d="M3.375 9.16667C3.58574 7.55895 4.37518 6.08315 5.59557 5.01552C6.81595 3.94789 8.38359 3.36163 10.0051 3.36647C11.6265 3.37132 13.1906 3.96695 14.4046 5.04186C15.6186 6.11677 16.3992 7.59726 16.6003 9.20621C16.8014 10.8152 16.4093 12.4423 15.4972 13.7829C14.5852 15.1236 13.2158 16.0859 11.6455 16.4897C10.0751 16.8935 8.41136 16.7112 6.96573 15.9768C5.5201 15.2424 4.39166 14.0064 3.79167 12.5M3.375 16.6667V12.5H7.54167"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
    />
</svg>

export default ({ form, discordServerError, isUtils }) => {

    const url = config.DISCORD_INTEGRATION_OAUTH;
    const urlBot = config.DISCORD_INTEGRATION_BOT;

    const dispatch = useDispatch();
    const discordToken = useSelector(({ auth }) => auth.shop).discord_token;

    const [servers, setServers] = useState([]);
    const [roles, setRoles] = useState([]);
    const isDark = useTheme();

    const [loadingRoles, setLoadingRoles] = useState(false);
    const [loadingServers, setLoadingServers] = useState(false);
    const [showTokenButton, setTokenButton] = useState(false);

    useEffect(() => {
        let interval;
        if(form.values.discord_integration && !discordToken) {
            interval = setInterval(() => {
                dispatch(getSelfUser())
            }, 5000)
        }

        return () => {
            clearInterval(interval)
        }
    }, [discordToken, form.values.discord_integration])


    useEffect(() => {

        let { discord_server_id, discord_role_id } = form.values;

        const findRole = () => {
            roles.forEach(role => {
                if (role.value === discord_role_id) {
                    form.setFieldValue('discord_role_id', role.value);
                }
            })
        };
        const findServer = () => {
            servers.forEach(server => {
                if (server.value === discord_server_id) {
                    form.setFieldValue('discord_server_id', server.value);
                }
            })
        }

        if (discord_server_id && servers.length) {
            findServer();
        }

        if (discord_role_id && roles.length) {
            findRole();
        }

    }, [servers.length, roles.length, form.values.discord_server_id, form.values.discord_role_id]);

    const getDiscordCode = () => {
        window.open(url, '_blank', 'noopener,noreferrer');
    }

    const redirectBot = () => {
        window.open(urlBot, '_blank', 'noopener,noreferrer');
    }

    const getServerRoles = (serverID) => {
        dispatch(getListRolesAction(serverID ? serverID : form.values.discord_server_id))
            .then(({ data }) => {
                if (data && data.roles && data.roles.length) {
                    let roles = [];
                    data.roles.forEach(({ id: value, name: label }) => {
                        roles.push({ value, label })
                    });
                    setRoles(roles);
                } else {
                    setRoles([]);
                }
            })
            .catch(error => {
                if (error.status === 400) {
                    setRoles([]);
                }
                throw error;
            })
            .finally(() => setLoadingRoles(false));
    }

    const getServerList = () => {

        dispatch(getListServersAction())
            .then(({ data }) => {
                if (data && data.servers && data.servers.length) {
                    let servers = [];
                    data.servers.forEach(({ id: value, name: label }) => {
                        servers.push({ value, label })
                    })

                    servers.push({ value: "none", label: "None" });
                    setServers(servers);
                } else {
                    setServers([]);
                }
            })
            .catch(error => {
                throw error;
            })
            .finally(() => setLoadingServers(false));
    };

    const handleRefreshRoles = () => {
        setLoadingRoles(true);
        getServerRoles();
    }

    const handleRefreshServers = () => {
        setLoadingServers(true);
        getServerList()
    }

    useEffect(() => {
        if(discordToken) {
            handleRefreshServers();
        }
    }, [discordToken]);

    useEffect(() => {
        if (form.values.discord_server_id && form.values.discord_set_role) {
            handleRefreshRoles();
        }
    }, [form.values.discord_server_id, form.values.discord_set_role]);


    const RoleLabel = <div className="w-100 align-items-end d-flex justify-content-between">
        <div className="d-flex flex-column">
            <div>Role</div>
            <div style={{ fontWeight: 400 }}>Select a role from the available ones in your server.</div>
        </div>
        <Button onClick={handleRefreshRoles}  square variant="secondary">
            <RefreshIcon />
        </Button>
    </div>;

    const ServerLabel = <div className="w-100 align-items-end d-flex justify-content-between">
        <div className="d-flex flex-column">
            <div>Server</div>
        </div>

        <Button square variant="secondary" onClick={handleRefreshServers}>
            <RefreshIcon />
        </Button>
    </div>;


    return <div className={`${!isUtils ? 'product-form-main-back' : 'switcher-container withBorder'} pb-3`}>
        <div>
            <Switch
                name="discord_integration"
                left
                label="Enable Discord integration"
                note="Check this option to enable our discord integration. Customers will be able to authenticate with their Discord account at checkout, you will also have the option to add them to one of your servers and apply a custom role."
                wrapperClassName={isUtils ? "" : "mb-2"}
                {...form}
            />

            {form.values.discord_integration ?
                <div className={isUtils ? "utils-discord" : ""}>
                    <Switch
                        name="discord_optional"
                        left
                        label="Optional"
                        note="Enable this option if you'd like to make the discord integration optional for your customers. They will not be required to connect their discord account at the moment of the checkout, but they will be prompted to."
                        wrapperClassName={isUtils ? "mb-2" : "mt-3 mb-2"}
                        {...form}
                    />

                    {
                        !discordToken ?
                            <Button onClick={getDiscordCode} type="button" size="large" className="mb-3">
                                Connect your <span className="mx-1" style={{ width: 85, height: 15 }}><Discord isDark={isDark} /></span> Account
                            </Button>
                            :
                            <div>
                                <a className="mt-3 mb-3 text-underline cursor-pointer paylixecommerce-label" onClick={() => setTokenButton(!showTokenButton)}>Click here to change your linked discord account</a>
                                {
                                    showTokenButton ?
                                        <div className="d-flex justify-content-between">
                                            <Button onClick={getDiscordCode} type="button" size="large">
                                                Connect your <span className="mx-1" style={{ width: 85, height: 15 }}><Discord isDark={isDark} /></span> Account
                                            </Button>
                                            <Button onClick={handleRefreshServers}  square variant="secondary">
                                                <RefreshIcon />
                                            </Button>
                                        </div>
                                        : null
                                }
                            </div>
                    }

                    {
                        discordToken ?
                            <div className="mt-3">
                                {
                                    servers.length > 0 ?
                                        <SimpleSelect
                                            showEmpty
                                            label={ServerLabel}
                                            noteUnder
                                            style={discordServerError ? { borderColor: "var(--red6)" } : {}}
                                            disabled={loadingServers}
                                            note="Choose the Discord server into which the customer will be added. If the customer is already on this server, this will be skipped automatically."
                                            onChange={(e) => {
                                                form.setFieldValue('discord_server_id', e.target.value);
                                                setRoles([]);
                                                setLoadingRoles(true);
                                                // getServerRoles(e.target.value);
                                            }}
                                            placeholder="Select a server"
                                            options={servers}
                                            name="discord_server_id"
                                            {...form}
                                        />
                                        : null
                                }

                                {discordServerError ? <div style={{ marginTop: "-.75rem" }} className="invalid-feedback d-flex w-100">{discordServerError}</div> : null}

                                {form.values.discord_server_id ?
                                    <Switch
                                        wrapperClassName="mt-3"
                                        name="discord_set_role"
                                        left
                                        withBorder={form.values.type === "SUBSCRIPTION"}
                                        {...form}
                                        label="Set a custom role"
                                        note="Check this option if you'd like to also set a custom role to the customer, who's been added to your Discord server."
                                    />
                                : null}

                                {
                                        form.values.discord_set_role && !loadingRoles ?
                                            <div>
                                                {
                                                    roles.length > 0 ?
                                                        <SimpleSelect
                                                            wrapperClassName="mt-3"
                                                            label={RoleLabel}
                                                            disabled={loadingRoles}
                                                            onChange={(e) => form.setFieldValue('discord_role_id', e.target.value)}
                                                            placeholder="Select a role"
                                                            options={roles}
                                                            name="discord_role_id"
                                                            {...form}
                                                        />
                                                        :
                                                        (form.values.discord_server_id ?
                                                            <div className="mt-3 d-flex justify-content-between">
                                                                <Button onClick={redirectBot} type="button" size="large">
                                                                    Invite our Bot to your <span className="mx-1" style={{ width: 85, height: 15 }}><Discord isDark={isDark} /></span> server
                                                                </Button>
                                                                <Button square variant="secondary" onClick={handleRefreshRoles}>
                                                                    <RefreshIcon />
                                                                </Button>
                                                            </div>
                                                            : null)
                                                }
                                            </div>
                                        : null
                                }

                                {(isUtils || form.values.type === "SUBSCRIPTION")  ?
                                    <Switch
                                        wrapperClassName={isUtils ? "mb-0 mt-3" : "mt-3"}
                                        name="discord_remove_role"
                                        label="Remove the custom role"
                                        left
                                        {...form}
                                        note="Enable this option if you'd like to remove the role automatically if the customer cancel the subscription (or the subscription is cancelled after x payment retries)."
                                        style={{ marginBottom: "1rem" }}
                                    />
                                    :
                                    null}

                            </div>
                            : null
                    }
                </div>
            : null}
        </div>

    </div>
}